var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.641 5.367C14.164 2.469 11.211.5 7.875.5 4.512.5 1.559 2.469.082 5.367.027 5.477 0 5.613 0 5.75c0 .164.027.301.082.41C1.559 9.059 4.512 11 7.875 11c3.336 0 6.289-1.941 7.766-4.84.055-.109.082-.246.082-.383 0-.164-.027-.301-.082-.41zm-7.766 4.32A3.92 3.92 0 0 1 3.938 5.75a3.94 3.94 0 0 1 3.938-3.937 3.96 3.96 0 0 1 3.938 3.938v.027a3.96 3.96 0 0 1-3.937 3.938v-.027zm0-6.562l-.711.109c.164.219.246.492.246.793 0 .711-.574 1.285-1.285 1.285-.301 0-.574-.082-.793-.246a2.92 2.92 0 0 0-.082.684c0 1.449 1.176 2.625 2.625 2.625S10.5 7.199 10.5 5.75 9.324 3.152 7.875 3.152v-.027z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.34dc82e5378a77fa845ad0b171e0ef4f.svg";
export { ForwardRef as ReactComponent };